<template>
  <div class="WorkOrderDetailModal">
    <el-dialog
        title="详情查看"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @open="handleOpen"
        width="30%"
    >
      <div v-for="material in row.materials" style="height: 550px;overflow: auto">
        <div v-if="material.mimeType.startsWith('image')" style="text-align: center">
          <el-image
              style="width: 100%;"
              :src="material.url"
              :lazy="true"
              object-fit="scale-down"
              :preview-src-list=[material.url]
              initial-index="1"
          >
          </el-image>
        </div>
        <div v-else>
          <el-link :href="material.url" :underline="true">
            <el-button
                type="text"
                icon="el-icon-download"
                size="medium">
              {{ material.name }}
            </el-button>
          </el-link>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {mapMutations} from "vuex";

export default {
  name: "WorkOrderDetailModal",
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
    isAnswer: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.fuzhu.workOrderListModalVisible;
      },
      set(value) {
        this.$store.commit("fuzhu/setData", {
          key: "workOrderListModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("fuzhu", ["setData"]),
    handleOpen() {
    },
    handleClose() {
      this.setData({
        key: "workOrderListModalVisible",
        value: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.WorkOrderDetailModal {
  ::v-deep .el-dialog {
    min-width: 750px;
    height: 750px;
  }

  .lessonNameBox {
    ::v-deep .el-input__inner {
      background-image: none;
      border-radius: 4px;
      border: none;
      box-sizing: border-box;
      color: #606266;
      cursor: default;
    }
  }

  .questionBox {
    padding: 10px 20px;
    background: #efefef;
    margin-top: 10px;
    margin-bottom: 20px;
    min-height: 300px;

    .imageBox {
      width: 320px;
      height: 180px;
      overflow: hidden;
    }
  }

  .textareaBox {
    display: inline-block;
    width: 100%;

    textarea {
      min-height: 120px !important;
      height: auto;
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
      border: 1px solid #dcdfe6 !important;
      resize: none;
      line-height: 1.5;
      font-family: inherit;
      color: #606266;
      font-size: inherit;
    }
  }

  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;
  }
}
</style>
